module.exports = __webpack_public_path__ + "static/media/celabrate_gray.7290d8e9.svg";